import React from 'react'
import { observer } from 'mobx-react';

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
} from "@chakra-ui/react"
import ReactJson from 'react-json-view'

const AddBotModal = ({ isOpen, onClose, data }) => {

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="3xl" closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Bot details</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <ReactJson src={data} />
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default observer(AddBotModal);
